const populateExpandProperties = ({ apiParameter, apiResult }: any) => {
    if (apiParameter && apiResult) {
        [...(apiParameter?.expand ?? []), ...(apiParameter?.additionalExpands ?? [])].forEach(x => {
            const data = apiResult[x];

            if (data) {
                try {
                    data.properties = { ...JSON.parse(apiResult.properties[x]), ...data.properties };
                } catch {
                    // Do not populate
                }
            }
        });
    }
};

export default populateExpandProperties;
